import {
  GET_LATEST_INSURANCES_ERROR,
  GET_LATEST_INSURANCES_SUCCESS,
  GET_LATEST_INSURANCES_REQUEST,
} from '../../constants/latestInsurancesActionNames';
import { getLocalStorage } from '../../storage/localStorage';
import { anonymizePayload } from '../../utils/functions';
import { anonymizeStorage } from '../../utils/variables';

export const initialState = {
  isFetching: false,
  data: [],
  error: null,
};
const latestInsurancesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LATEST_INSURANCES_REQUEST: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case GET_LATEST_INSURANCES_SUCCESS: {
      const _payload = action?.payload;
      let payload = { ..._payload };
      const anonymizeUserId = getLocalStorage(anonymizeStorage);
      if (anonymizeUserId) {
        payload = anonymizePayload(payload, anonymizeUserId);
      }
      return {
        ...state,
        isFetching: false,
        data: payload,
      };
    }
    case GET_LATEST_INSURANCES_ERROR: {
      const payload = action?.payload;
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    }
    default:
      return state;
  }
};

export default latestInsurancesReducer;
